import type { BillingPlan } from '~/types/billing';

const BLUEPRINT_LABELS: Record<string, string> = {
  single_asset: 'Quick Asset',
  launch_sprint: 'Launch Sprint',
  awareness_social: 'Social Awareness',
  conversion_push: 'Conversion Push',
  brand_refresh: 'Brand Refresh',
  full_social_launch: 'Full Social Launch',
};

function getAiTierLabel(plan: BillingPlan): string {
  const modelConfig = plan.limits.modelConfig ?? {};
  const perplexity = modelConfig.perplexity ?? '';
  const hasReasoning = perplexity.includes('reasoning');
  const hasSonarPro = perplexity.includes('sonar-pro');

  if (hasReasoning) return 'Best AI models + Deep reasoning';
  if (hasSonarPro) return 'Pro AI models + Enhanced research';
  return 'Standard AI + Image generation';
}

export function describePlanAi(plan: BillingPlan): string {
  return getAiTierLabel(plan);
}

export function describeBlueprintAccess(
  allowedBlueprintKeys: string[] | null,
): string {
  if (allowedBlueprintKeys == null) return 'All campaign templates';
  if (allowedBlueprintKeys.length === 0) return 'No campaign templates';

  const labels = allowedBlueprintKeys
    .map((key) => BLUEPRINT_LABELS[key] ?? key)
    .filter(Boolean);

  if (labels.length <= 2) {
    return labels.join(' + ');
  }

  return `${labels.length} campaign templates`;
}
